import client from "./client";

export default {

    async getTransactionTypes(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/transaction-types', filters)));
    },
}
